import { Suspense, useState } from 'react';
import { Redirect, Router } from '@reach/router';

import { PageLayout } from 'components/PageLayout';
import { CookieBanner } from 'components/CookieBanner';
import { Spinner } from 'components/Spinner';

import { Checkout } from './Checkout';
import { NotFound } from './NotFound/NotFound';
import { Confirmation } from './Confirmation';
import { MerchantGiftCardOnly } from './GiftCard';

import { CLIENT_PATH } from 'olo-service/axiosInstance';
import style from './app.module.scss';
import { Merchant } from './Merchant';
import { AppMenuPage } from 'components/AppMenuPage/AppMenuPage';
import { AppDownloadPage } from 'components/AppDownloadPage';
import { LandingPage } from 'components/LandingPage';
import { MerchantLink } from 'components/MerchantLink';

export const App = () => {
  const [marginTop, setMarginTop] = useState(0);

  return (
    <>
      <MerchantLink />
      <Suspense fallback={<PageLayout><Spinner /></PageLayout>}>
        <CookieBanner onScrollHeightChanged={setMarginTop} />
        <Router basepath={CLIENT_PATH} data-testid="app" className={style.app} style={{ marginTop }}>
          <NotFound path="not-found" />
          <Redirect noThrow from="/*" to="not-found"></Redirect>
          <AppMenuPage path="app/menu/*" />
          <AppDownloadPage path="app/*" />
          <Merchant path=":merchantId">
            <LandingPage path="/*" />
            <Checkout path="checkout/*" />
            <Confirmation path="status" />
            <MerchantGiftCardOnly path="giftcard" />
          </Merchant>
        </Router>
      </Suspense>
  </>
  );
};
